import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Calendar from "./CalanderComponents/Calendar";

const EventCalander = () => {
  const location = useLocation();

  // Variants for animation
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.05, // Adjust delay as needed
        type: "spring",
        stiffness: 120,
      },
    }),
  };

  // Add `\n` where you want a line break
  const headingText = "Your MSB Community Events Hub";

  useEffect(() => {
    let previousHighlightedId = null; // Keep track of the last highlighted ID

    const highlightElement = (id) => {
      const element = document.getElementById(id);

      if (element) {
        // Reset the previously highlighted element
        if (previousHighlightedId && previousHighlightedId !== id) {
          const prevElement = document.getElementById(previousHighlightedId);
          if (prevElement) {
            prevElement.classList.remove("highlight");
            prevElement.classList.add("fade-out");
            setTimeout(() => {
              prevElement.classList.remove("fade-out");
            }, 2000); // Remove fade-out after animation completes
          }
        }

        // Highlight the current element
        // element.classList.add("highlight");
        setTimeout(() => {
          element.classList.remove("highlight");
          element.classList.add("fade-out");
          setTimeout(() => {
            element.classList.remove("fade-out");
          }, 2000); // Remove fade-out after animation completes
        }, 2000); // Highlight duration

        // Highlight the next element (if it exists)
        const allElements = Array.from(document.querySelectorAll("[id]"));
        const currentIndex = allElements.findIndex((el) => el.id === id);

        if (currentIndex !== -1 && currentIndex + 1 < allElements.length) {
          const nextElement = allElements[currentIndex + 1];
          nextElement.classList.add("highlight");
          setTimeout(() => {
            nextElement.classList.remove("highlight");
            nextElement.classList.add("fade-out");
            setTimeout(() => {
              nextElement.classList.remove("fade-out");
            }, 2000);
          }, 2000); // Highlight duration
        }

        // Update the previously highlighted ID
        previousHighlightedId = id;
      }
    };

    if (location.hash) {
      const hashId = location.hash.substring(1); // Remove '#' from the hash
      highlightElement(hashId);
    }
  }, [location]);

  const title = "Event Calendar";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.1, // Delay each letter animation
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>Event Calendar | MSB Association</title>
        <meta name="description" content="" />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Calendar | MSB Association" />
        <meta property="og:description" content="" />

        <meta
          property="og:image"
          content="https://msbassociationuk.org/assets/images/logo.svg"
        />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
================================================== */}
        <section className="page_header text-center section_decoration overflow-hidden eventbg-image-css">
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{
                display: "flex",
                flexDirection: "column", // stack lines vertically
                alignItems: "center",
                textAlign: "center",
                flexWrap: "wrap",
              }}
            >
              {title
                .replace(/\/n/g, "\n") // Convert "/n" to actual line breaks
                .split("\n")
                .map((line, lineIndex) => (
                  <div
                    key={`line-${lineIndex}`}
                    style={{
                      display: "flex",
                      flexWrap: "wrap", // ensure words wrap on smaller screens
                      justifyContent: "center",
                    }}
                  >
                    {line.split("").map((letter, charIndex) => {
                      const uniqueIndex = lineIndex * 30 + charIndex;
                      return (
                        <motion.span
                          key={`char-${lineIndex}-${charIndex}`}
                          custom={uniqueIndex}
                          initial="hidden"
                          animate="visible"
                          variants={letterVariants}
                          style={{
                            display: "inline-block",
                            marginRight: letter === " " ? "0.3rem" : "0",
                            whiteSpace: "pre",
                          }}
                        >
                          {letter}
                        </motion.span>
                      );
                    })}
                  </div>
                ))}
            </motion.h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/whats-happening">What's Happening</NavLink>
              </li>
              <li className="active">
                <a href="#!">Event Calendar</a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="d-flex justify-content-end">
              <NavLink to="/whats-happening" className="btn bg-primary text-dark">
                &larr; Back
              </NavLink>
            </div>
            <div className="item_details_content p-3">
              <h2 className="item_details_heading text-center">
                {headingText.split("").map((char, i) => {
                  if (char === "\n") {
                    return <br key={`br-${i}`} />;
                  }
                  return (
                    <motion.span
                      key={`${char}-${i}`}
                      custom={i}
                      initial="hidden"
                      animate="visible"
                      variants={headingVariants}
                    >
                      {char}
                    </motion.span>
                  );
                })}
              </h2>
              <p className="text-center">
               Explore key dates, MSB meetups, and learning opportunities across the UK MSB landscape.
              </p>
              <Calendar />
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default EventCalander;
